export default __webpack_public_path__ + "static/pic14-e93ad821042aa97a9504ea562c3099ab.jpg";